var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ca-collapse-table',_vm._l((_vm.reports),function(report,index){return _c('report-center-table-row',{key:index,attrs:{"report":report}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }